module.exports = __webpack_public_path__ + "static/img/1_5_1.32feff48.jpg";